import { atom, useRecoilState } from "recoil";
import appConfig from "../config/app.config";

import { API_STATUS } from "../constants/app.constants";
import useRestApiCall from "../http.interceptor";

const { LOADING, SUCCESS, ERROR } = API_STATUS;

const CUSTOMER_INFORMATION_INITIAL_STATE = {
    status: LOADING,
    content: null
};

const customerInformationAtom = atom({
    key: "apiProductsInitialState",
    default: CUSTOMER_INFORMATION_INITIAL_STATE
});

const customerInformationPayload = () =>{
    let apiPayload = {
        method: "GET",
        url: "/api/auth/get/customer/information",
        baseURL: appConfig.apiMarketplaceBaseUrl,
        headers: {
          "Content-type": "application/json",
          
        }
    }

      return apiPayload;
}

const useCustomerInformation = () => {

    const { apiCall } = useRestApiCall();
    const [customerInformation, setCustomerInformation] = useRecoilState(customerInformationAtom);
    const { content, status } = customerInformation;

    const fetchCustomerInformation = async () => {
        try {
          const apiPayload = customerInformationPayload(); 
          const response  = await apiCall(apiPayload);
          if(response?.data) {
              setCustomerInformation({status: SUCCESS, content: response.data });
              return;
          }
          throw new Error(response);

        }
        catch(error){
            setCustomerInformation({status: ERROR, content: error });
        }

    }

    return { content, fetchCustomerInformation, status }
}

export default useCustomerInformation;